import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import SearchInput from '@/components/common/search-input';
import ContactGroupList from '@/components/contacts/contact-list/contact-group-list';
import ContactList from '@/components/contacts/contact-list/contact-list';
import ContactTabs from '@/components/contacts/contact-tabs';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import useSortedFriends from '@/hooks/contacts/use-sorted-friends';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { setPanel } from '@/stores/layout-status';

export default function ContactIndexRoute() {
  const { t } = useTranslation();
  const { sortedFriends, isLoading } = useSortedFriends();
  const { isEmbedded } = useUserPlatform();

  return (
    <PageLayout
      key='nav.contact'
      title={t('nav.contact')}
      className='gap-0 pb-safe-offset-16 desktop:pb-0 desktop:h-screen'
      headerConfig={{
        actions: <AppHeaderMenu />,
        showHeader: !isEmbedded,
        elementAfterNav: (
          <div className='bg-neutral-0 py-0.5'>
            <Link
              className='mx-3 block'
              to={ROUTES.SEARCH.$path()}
              onClick={() => setPanel('search')}>
              <SearchInput
                className='pointer-events-none'
                keyword=''
              />
            </Link>
            <ContactTabs />
          </div>
        ),
      }}>
      <LoadingLayout
        overlay
        promise={isLoading}>
        {() => (
          <div className='overflow-y-auto flex-1'>
            <ContactGroupList />
            <ContactList
              virtualizeAs='window'
              friends={sortedFriends}
              itemClassName='desktop:px-5'
            />
          </div>
        )}
      </LoadingLayout>
    </PageLayout>
  );
}
